







































































import { Component, Vue } from 'vue-property-decorator';
import storeaddressInfo from '@/store/entities/back-storeaddress-list';

interface BatchDetailItem {
    name: string;         // 批次号
    logisticMethod: string; // 运输方式
    count: number;        // 快递数量
}

@Component({
    name: "backDeliveryreceiptScan"
})
export default class ScanComponent extends Vue {
    storeaddressList: Array<storeaddressInfo> = [];
    private storeId: number;
    // 扫描输入框的值
    private scanInput: string = '';

    // 扫描结果（多行文本）
    private scanResult: string = '';

    // 批次号
    private batchNumber: string = '';

    // 已扫描的快递集合（用于去重）
    private scannedPackages: Set<string> = new Set();

    // 批次详情弹框相关
    private batchDetailVisible: boolean = false;
    private batchDetailData: BatchDetailItem[] = [];
    private selectedBatchItems: BatchDetailItem[] = [];

    // 批次详情表格列配置
    private batchColumns = [
        {
            type: 'selection',
            width: 60,
            align: 'center'
        },
        {
            title: '批次号',
            key: 'name',
            align: 'center'
        },
        {
            title: '运输方式',
            key: 'logisticMethod',
            align: 'center'
        },
        {
            title: '快递数量',
            key: 'count',
            align: 'center'
        }
    ];

    // 选择变化处理方法
    private handleBatchSelection(selection: BatchDetailItem[]): void {
        this.selectedBatchItems = selection;
    }

    // 处理扫描事件
    private handleScan(): void {
        const packageCode = this.scanInput.trim();

        if (!packageCode) {
            // 清空输入框，准备下一次扫描
            this.scanInput = '';
            return;
        }

        // 检查是否已扫描过
        if (this.scannedPackages.has(packageCode)) {
            // 清空输入框，准备下一次扫描
            this.scanInput = '';
            return;
        }

        // 添加到已扫描集合
        this.scannedPackages.add(packageCode);

        // 更新扫描结果
        if (this.scanResult) {
            this.scanResult += `,${packageCode}`;
        } else {
            this.scanResult = packageCode;
        }

        // 清空输入框，准备下一次扫描
        this.scanInput = '';
    }

    // 处理生成按钮点击
    private handleGenerate(): void {
        if (!this.scanResult) {
            this.$Message.warning('请先扫描快递');
            return;
        }
        var count = this.scanResult.replace("，", ",").split(',').length;
        var title = "总共" + count + "快递,确认生成该交接批次。";
        if (this.batchNumber) {
            title = "总共" + count + "快递,确认生成到指定的[" + this.batchNumber + "]交接批次";
        }
        var _this = this;
        this.$Modal.confirm({
            title: "生成批次", content: title , width: 800, onOk: async () => {
                setTimeout(() => {
                    _this.processData();
                }, 500);
            }
        });

    }
    private async processData(): Promise<void> {
        var result = await this.$store.dispatch({
            type: 'deliveryreceipt/add',
            data: { BatchNumber: this.batchNumber, Logistics: this.scanResult.replace("，", ",").split(','), StoreId: this.storeId }
        });
        this.batchNumber = result;
        this.handleBatchDetail();
    }

    // 处理重置按钮点击
    private handleReset(): void {
        this.scanInput = '';
        this.scanResult = '';
        this.batchNumber = '';
        this.scannedPackages.clear();
        this.$Message.success('已重置');
    }

    // 处理批次详情按钮点击
    private async handleBatchDetail(): Promise<void> {
        if (!this.batchNumber) {
            this.$Message.warning('请输入批次号');
            return;
        }

        if (!this.storeId) {
            this.$Message.warning('请选择仓库');
            return;
        }

        const response = await this.$store.dispatch({
            type: 'deliveryreceipt/getBatchNumberList',
            data: {
                batchNumber: this.batchNumber,
                storeId: this.storeId
            }
        });
        if (response.length == 0) {
            this.$Message.warning('该批次号内容为空，请确认批次号是否正确！');
            return;
        }
        // 假设返回的数据就是我们需要展示的列表
        this.batchDetailData = response;
        this.batchDetailVisible = true;

    }
    private handleGenerateTransfer(): void {
        if (this.selectedBatchItems.length === 0) {
            this.$Message.warning('请至少选择一项生成交接单');
            return;
        }
        this.$store.dispatch({
            type: 'deliveryreceipt/getDeliveryReceip',
            data: {
                batchName: this.batchNumber,
                storeId: this.storeId,
                logisticMethod: this.selectedBatchItems.map(item => item.logisticMethod).join(','),
                userId: abp.session.userId
            }
        });
    }

    async created() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        //this.storeaddressList.push(a);
        this.storeId = this.storeaddressList[0].id;
    }
}
